export const gradeFromGradYear = (gradYear: number): number => {
  const now = new Date();

  const year = now.getFullYear();
  const month = now.getMonth();

  const schoolYear = month >= 7 ? year + 1 : year;

  const fullGradYear = 2000 + gradYear;

  const grade = 12 - (fullGradYear - schoolYear);

  return Math.min(12, Math.max(1, grade));
};
